var React = require('react');

function ArrowBottom (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_359_12529)","key":0},React.createElement("path",{"d":"M12.6658 1.62056C12.8719 1.43778 13.1874 1.45383 13.3727 1.65751C13.5573 1.86159 13.5407 2.17658 13.3356 2.36007L8.33459 6.83923C8.14318 7.00932 7.85615 7.00932 7.66459 6.83923L2.69271 2.36075C2.48765 2.17707 2.47102 1.86221 2.65559 1.65819C2.85155 1.44304 3.16777 1.44724 3.36246 1.62124L8.00022 5.79954L12.6658 1.62056Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_359_12529"},React.createElement("rect",{"width":"7.96173","height":"16","fill":"white","transform":"translate(0 7.96191) rotate(-90)"})))]);
}

ArrowBottom.defaultProps = {"width":"16","height":"8","viewBox":"0 0 16 8","fill":"none"};

module.exports = ArrowBottom;

ArrowBottom.default = ArrowBottom;
